module.exports = function () {
  var cnpj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
};